import React from 'react';
import css from './AdminContainer.module.css';

type AdminContainerProps = {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  fullHeight?: boolean;
  fitWidth?: boolean;
  noPadding?: boolean;
  noBorder?: boolean;
  noShadow?: boolean;
  isRow?: boolean;
  style?: React.CSSProperties;
};

const AdminContainer: React.FC<AdminContainerProps> = ({
  children,
  className,
  fullWidth = false,
  fullHeight = false,
  fitWidth = false,
  noPadding = false,
  noBorder = false,
  noShadow = false,
  isRow = false,
  style
}) => {
  const containerClasses = [
    css.container,
    isRow ? css.row : css.column,
    fullWidth ? css.fullWidth : '',
    fullHeight ? css.fullHeight : '',
    fitWidth ? css.fitWidth : '',
    noPadding ? css.noPadding : '',
    noBorder ? css.noBorder : '',
    noShadow ? css.noShadow : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} style={style}>
      {children}
    </div>
  );
};

export default AdminContainer;